export const BlogActionTypes = {
    SET_BLOGS: 'SET_BLOGS'
}

export const setBlogs = (blogs) => {
    return {
        type: BlogActionTypes.SET_BLOGS,
        blogs
    };
}